import React, { useEffect, useState } from 'react'
import styles from './AdminPage.module.scss'
import { Layout } from 'components'

import { useDispatch } from 'react-redux'
import right from 'assets/icons/chevron_right.png'

import { useNavigate } from 'react-router-dom'
import {
  getOrganization,
  getAllCommand,
} from 'service/AdminService'
import userInfo from 'utils/userInfo'

import Notification from 'utils/Notifications'

const AdminPage = () => {

  const [data, setData] = useState('')
  const [data1, setData1] = useState('')
  const [render, setRender] = useState(false)
  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })


  const navigate = useNavigate()
  const user = userInfo()


  const getData = async () => {
    try {
      let response = await getOrganization(data)
      let response_command = await getAllCommand(data1)
      setData(response.data)
      setData1(response_command.data)

    } catch (error) {
      console.log("onoxo")
    }
  }

  useEffect(() => {
    if (user?.is_admin_of) {
      getData()
    }
    else {
      navigate("/home/")
    }
    setRender(false)
  }, [render])






  return (
    <Layout>
      {user?.is_admin_of ? (
        <>
          <div className={styles.project__wrapper}>
            <div className={styles.project__header}>
              <div className={styles.title}>
                Администрация
                <img
                  src={right}
                  alt=""
                  style={{
                    paddingLeft: '10px',
                    paddingRight: '10px',
                    verticalAlign: 'middle',
                  }}
                />
              </div>

            </div>
            <div className={styles.project__header2}>
              <div className={styles.title2}>
                <h4>Компании</h4>
              </div>
            </div>
            <div className={styles.project__body}>
              <table className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                  <tr className={styles.table__row}>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Компания</span>
                    </th>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Создан </span>
                    </th>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Администратор </span>
                    </th>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Количество команд</span>
                    </th>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Количество пользователей</span>
                    </th>


                  </tr>
                </thead>

                <tbody className={styles.table__body}>
                  {Array.isArray(data) && data.map((item) => (
                    <tr
                      className={styles.table__row}
                      style={{ zIndex: '1' }}
                    // onClick={() => handleClickInfo(item.id)}
                    >
                      <td className={styles.table__item}>
                        <span
                          className={styles.table__title}
                          style={{ fontWeight: '700' }}
                        >
                          {item.title}
                        </span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>{item.created}</span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.employee}
                        </span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.command_count}
                        </span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.employee_count}
                        </span>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
            <div className={styles.project__header2}>
              <div className={styles.title2}>
                <h4>Команды</h4>
              </div>
            </div>
            <div className={styles.project__body}>
              <table className={styles.table__wrapper}>
                <thead className={styles.table__head}>
                  <tr className={styles.table__row}>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Наименование</span>
                    </th>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Создан </span>
                    </th>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Администратор </span>
                    </th>
                    <th className={styles.table__item}>
                      <span className={styles.table__title}>Количество участников</span>
                    </th>


                  </tr>
                </thead>

                <tbody className={styles.table__body}>
                  {Array.isArray(data1) && data1.map((item) => (
                    <tr
                      className={styles.table__row}
                      style={{ zIndex: '1' }}
                    // onClick={() => handleClickInfo(item.id)}
                    >
                      <td className={styles.table__item}>
                        <span
                          className={styles.table__title}
                          style={{ fontWeight: '700' }}
                        >
                          {item.name_team}
                        </span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>{item.date_create}</span>
                      </td>
                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.employee_name}
                        </span>
                      </td>

                      <td className={styles.table__item}>
                        <span className={styles.table__title}>
                          {item.members.length}
                        </span>
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>

            </div>
          </div>


          <Notification notify={notify} setNotify={setNotify} />
        </>
      ) : (
        ""
      )}{" "}
    </Layout>
  )
}

export default AdminPage
